import { cn } from '@common/utils';
import Image from 'next/image';

export const CertificationBadge = ({
  isDark = false,
  size = 40,
  isHideISMSP,
  isHideERIVACY,
  unoptimized = false,
  className,
}: {
  isDark?: boolean;
  size?: 40 | 50 | 60 | 80;
  isHideISMSP?: boolean;
  isHideERIVACY?: boolean;
  unoptimized?: boolean;
  className?: string;
}) => {
  return (
    <ul className={cn('flex items-center gap-24', className)}>
      {isHideISMSP ? null : (
        <li className="flex items-center gap-12">
          <div
            className={cn('flex items-center justify-center', {
              'size-40': size === 40,
              'size-50': size === 50,
              'size-60': size === 60,
              'size-80': size === 80,
            })}
          >
            <Image
              unoptimized={unoptimized}
              className={cn({
                'size-40': size === 40,
                'size-50': size === 50,
                'size-60': size === 60,
                'size-80': size === 80,
              })}
              alt="ISMS-P 로고"
              src={
                isDark
                  ? 'https://cdn.wellobiz.com/certificate/ISMS-P.png'
                  : 'https://cdn.welfarehello.com/certificate/ISMS-P.png'
              }
              width={80}
              height={80}
            />
          </div>
          <p className="font-400 text-Gray-600 typo-caption2">
            <span className="font-600 text-Gray-700">ISMS-P</span>
            <br />
            [인증범위] 웰로 서비스 및 웰로비즈 서비스
            <br />
            [유효기간] 2024-11-20 ~ 2027-11-19
          </p>
        </li>
      )}
      <li className="flex items-center gap-12">
        <div
          className={cn('flex items-center justify-center', {
            'size-40': size === 40,
            'size-50': size === 50,
            'size-60': size === 60,
            'size-80': size === 80,
          })}
        >
          <Image
            alt="ISO27001 로고"
            className={cn({
              'w-23': size === 40,
              'w-[28.75px]': size === 50,
              'w-34': size === 60,
              'w-46': size === 80,
            })}
            width={80}
            unoptimized={unoptimized}
            height={80}
            src={
              isDark
                ? 'https://cdn.wellobiz.com/certificate/ISO-27001.png'
                : 'https://cdn.welfarehello.com/certificate/ISO-27001.png'
            }
            title="ISO27001"
          />
        </div>
        <p className="font-400 text-Gray-600 typo-caption2">
          <span className="font-600 text-Gray-700">ISO 27001</span>
          <br />
          [인증범위] 웰로 서비스 및 웰로비즈 서비스
          <br />
          [유효기간] 2024-12-02 ~ 2027-12-01
        </p>
      </li>
      <li className="flex items-center gap-12">
        <div
          className={cn('flex items-center justify-center', {
            'size-40': size === 40,
            'size-50': size === 50,
            'size-60': size === 60,
            'size-80': size === 80,
          })}
        >
          <Image
            alt="ISO27701 로고"
            className={cn({
              'size-40': size === 40,
              'size-50': size === 50,
              'size-60': size === 60,
              'size-80': size === 80,
            })}
            unoptimized={unoptimized}
            src={
              isDark
                ? 'https://cdn.wellobiz.com/certificate/ISO-27701.png'
                : 'https://cdn.welfarehello.com/certificate/ISO-27701.png'
            }
            title="ISO27701"
            width={80}
            height={80}
          />
        </div>
        <p className="font-400 text-Gray-600 typo-caption2">
          <span className="font-600 text-Gray-700">ISO 27701</span>
          <br />
          [인증범위] 웰로 서비스 및 웰로비즈 서비스
          <br />
          [유효기간] 2024-12-24 ~ 2027-12-23
        </p>
      </li>
      {isHideERIVACY ? null : (
        <li className="flex items-center gap-12">
          <div
            className={cn('flex items-center justify-center', {
              'size-40': size === 40,
              'size-50': size === 50,
              'size-60': size === 60,
              'size-80': size === 80,
            })}
          >
            <Image
              alt="ePRIVACY"
              className={cn({
                'size-40': size === 40,
                'size-50': size === 50,
                'size-60': size === 60,
                'size-80': size === 80,
              })}
              unoptimized={unoptimized}
              width={80}
              height={80}
              src="https://cdn.welfarehello.com/certificate/Wello+Design+Library+1.0.png"
              title="ePRIVACY"
            />
          </div>
          <p className="font-400 text-Gray-600 typo-caption2">
            <span className="font-600 text-Gray-700">ePRIVACY</span>
            <br />
            [인증범위] 웰로 서비스 및 웰로비즈 서비스
            <br />
            [유효기간] 2025-4-1 ~ 2026-3-31
          </p>
        </li>
      )}
    </ul>
  );
};
